import {LayoutDefinition} from '../layout/layout-definition';

export enum LayoutPresetCategory {
    BASIC = 'BASIC',
    ADVANCED = 'ADVANCED'
}

export interface LayoutPreset {
    body: LayoutDefinition;
    category: LayoutPresetCategory;
    id: number;
    image: string;
    name: string;
}
